import { Controller } from "@hotwired/stimulus"

// Maneja el form de "Muro" (item tipo feed) del menu de navegacion.
//   - Al cambiar el select de feed, recarga el turbo-frame con los topics.
//   - Al elegir "+ Agregar tema" en el select de topic, abre el modal global
//     de creacion de topic via turbo-frame#modal (replica <option value="add">
//     del frontend).
//
// Uso en ERB:
//   <form data-controller="manage--menu-feed-form"
//         data-manage--menu-feed-form-fragment-url-value="/manage/.../feed_topics_fragment"
//         data-manage--menu-feed-form-section-id-value="123">
//     <select data-manage--menu-feed-form-target="feedSelect"
//             data-action="change->manage--menu-feed-form#feedChanged">...</select>
//     <turbo-frame id="menu_feed_topic_select_123">
//       <select data-action="change->manage--menu-feed-form#topicChanged">
//         ...
//         <option value="add" data-add-url="/manage/.../post_topics/new?context=menu_item">
//           + Agregar tema
//         </option>
//       </select>
//     </turbo-frame>
//   </form>

export default class extends Controller {
  static targets = ["feedSelect"]
  static values = { fragmentUrl: String, sectionId: String }

  feedChanged() {
    const feedId = this.feedSelectTarget.value
    if (!feedId) return

    const frameId = `menu_feed_topic_select_${this.sectionIdValue}`
    const frame = this.element.querySelector(`#${frameId}`)
    if (!frame) return

    const url = new URL(this.fragmentUrlValue, window.location.origin)
    url.searchParams.set("feed_id", feedId)
    url.searchParams.set("section_id", this.sectionIdValue)
    frame.src = url.toString()
  }

  topicChanged(event) {
    const select = event.target
    if (select.value === "add") {
      const url = select.selectedOptions[0]?.dataset.addUrl
      select.value = select.dataset.previousValue || ""
      if (url) {
        const modalFrame = document.getElementById("modal")
        if (modalFrame) modalFrame.src = url
      }
    } else {
      select.dataset.previousValue = select.value
    }
  }
}
